<template>
  <div>

    <div
      class="box mb-4 bg-theme-900 light:bg-theme-100"
      v-for="(entry, i) in entries"
      :key="'changelog-' + i"
    >
      <p class="leading-none text-sm">{{ entry.type }}</p>
      <p class="text-lg font-bold text-blue-200 light:text-blue-600 leading-none border-b border-blue-500 pb-1 mb-4">
        {{ $moment(entry.timestamp, 'X').format(config.dateFormats.display) }}
      </p>
      <div
        class="markdown"
        v-html="entry.markdown"
      ></div>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'
var md = require('markdown-it')()

export default {
  data() {
    return {
      entries: [],
      limit: 20,
    }
  },
  computed: {
    ...mapGetters({
      config: 'config/config',
      changelog: 'changelog/changelog',
    })
  },
  mounted() {
    this.entries = _.cloneDeep(this.changelog)
    // limit
    if (Object.entries(this.changelog).length > this.limit) {
      this.entries = this.entries.slice(0, this.limit)
    }
    this['changelog/seenAll']()
    this.getMarkdownFiles()
  },
  methods: {
    async getMarkdownFiles() {
      let requests = []
      this.entries.map(entry => {
        requests.push({
          entry,
          promise: axios({ url: '/changelogs/' + entry.timestamp + '.md', baseURL: '/' }),
        })
      })
      Promise.all(requests.map(r => r.promise))
        .then(values => {
          for (let i in values) {
            let request = requests[i]
            this.$set(request.entry, 'markdown', md.render(values[i].data))
          }
        })
    },
    ...mapActions([
      'changelog/seenAll'
    ])
  }
}
</script>
